import {integrationDocumentationModule} from "./integrationDocumentationModule";
import {IntegrationDocumentationService, WsdlIdentifier} from "./integrationDocumentationService";
import {groupBy} from "lodash";
import {IntegrationDocumentationParser} from "./integrationDocumentationParser";
import {LoadingService, RemoteExceptionHandler} from "../../../bower_components/front-end-web-commons";
import {IFilterService} from "angular";

class NlgIntegrationDocumentation {
    wsdlsByService: Record<string, WsdlIdentifier[]> = {}

    constructor(private integrationDocumentationService: IntegrationDocumentationService,
                loadingService: LoadingService,
                remoteExceptionHandler: RemoteExceptionHandler,
                private $filter: IFilterService) {
        loadingService(integrationDocumentationService.getWsdls())
            .then(wsdl => this.wsdlsByService = groupBy(wsdl, identifier => identifier.service))
            .catch(remoteExceptionHandler())
    }

    getWsdlContentLink(identifier: WsdlIdentifier) {
        return this.integrationDocumentationService.getWsdlContentLink(identifier)
    }

    getTranslatedWsdlName = (identifier: WsdlIdentifier): string => {
        const translateFilter = this.$filter<(key: string) => string>('translate');
        return translateFilter('integration.wsdl.wsdlName.' + identifier.wsdlName);
    }
}

integrationDocumentationModule.directive("nlgIntegrationDocumentation", function () {
    return {
        // @ts-ignore
        templateUrl: require("link!./nlgIntegrationDocumentation.html"),
        controller: NlgIntegrationDocumentation,
        controllerAs: "ctrl"
    }
})